import { Moment } from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { PermissionSetType, User } from 'api/models';
import { Configuration } from 'api/timesheets/configuration/configuration';
import { BlueGhostButton } from 'components/organisms/timesheets/common/style';
import { DrawerType } from 'components/organisms/timesheets/my-timesheet/constants';
import { useUserPermissionSetType } from 'hooks/permissions';
import { AddToCalendar, AddToOutlookCalendar } from './my-timesheet';
import { useTimesheetActions } from './timesheets-actions';
import { RejectNoteType, TimesheetStatus } from './types';

const ActionRow = styled.div`
  display: flex;
  > button {
    max-height: var(--height-base);
  }
`;

const NoteLength = styled.span`
  margin-left: var(--spacing-02);
`;

interface Props {
  setVisibleDrawer: (DrawerType: DrawerType | undefined) => void;
  startDate: Moment;
  currentUser: User;
  configuration: Configuration;
  isWeekFreezed: boolean;
  isProjectOwnerApproval: boolean;
  rejectNotes?: RejectNoteType[];
}

export const SecondaryBar: FC<Props> = ({
  setVisibleDrawer,
  startDate,
  currentUser,
  configuration,
  isWeekFreezed,
  rejectNotes,
  isProjectOwnerApproval,
}) => {
  const { timesheet } = useTimesheetActions(startDate, currentUser);
  const userPermissionType = useUserPermissionSetType();
  const isUserAdmin = userPermissionType === PermissionSetType.AccountAdmin;
  const showOnApproved =
    timesheet?.status !== TimesheetStatus.Approved || isProjectOwnerApproval;

  return (
    <>
      <ActionRow>
        {rejectNotes && rejectNotes.length > 0 && (
          <BlueGhostButton
            onClick={() => {
              setVisibleDrawer(DrawerType.RejectComment);
            }}
          >
            <FormattedMessage id="comments" />
            <NoteLength>({rejectNotes.length})</NoteLength>
          </BlueGhostButton>
        )}
        {configuration.integrationMeta.googleCalendarEnabled &&
        !(isWeekFreezed && !isUserAdmin) &&
        showOnApproved ? (
          <AddToCalendar
            onclick={() => {
              setVisibleDrawer(DrawerType.Integration);
            }}
          />
        ) : null}
        {configuration.integrationMeta.outlookCalendarEnabled &&
        !(isWeekFreezed && !isUserAdmin) &&
        showOnApproved ? (
          <AddToOutlookCalendar
            onclick={() => {
              setVisibleDrawer(DrawerType.Integration);
            }}
          />
        ) : null}
        {(configuration.enabledSourceTypes?.TASK ||
          configuration.enabledSourceTypes?.MILESTONE) &&
          !(isWeekFreezed && !isUserAdmin) &&
          showOnApproved && (
            <BlueGhostButton
              data-cy="timesheets.buttons.add_task"
              onClick={() => {
                setVisibleDrawer(DrawerType.TaskDrawer);
              }}
            >
              <FormattedMessage id="timesheets.buttons.add_task" />
            </BlueGhostButton>
          )}
        {configuration.enabledSourceTypes?.ADHOC &&
          !(isWeekFreezed && !isUserAdmin) &&
          showOnApproved && (
            <BlueGhostButton
              onClick={() => {
                setVisibleDrawer(DrawerType.AdhocTaskDrawer);
              }}
              data-cy="buttons.timesheet.add-activity"
            >
              <FormattedMessage id="timesheets.buttons.add_adhoc_activity" />
            </BlueGhostButton>
          )}
      </ActionRow>
    </>
  );
};
